import React, { useContext } from 'react';
import styled from 'styled-components/macro';
import H2 from './H2';
import H5 from './H5';
import Carousel from './Carousel';
import { TABLET_WIDTH } from '../../constants/dims';
import PreferencesContext from '../../contexts/preferences';
import ScrollTo from './ScrollTo';

const Section = styled.section`
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;
  color: ${props => props.theme.howKidsImprove.text};
  background-color: ${props => props.theme.howKidsImprove.backgroundColor};
  padding: 40px 20px;
  box-sizing: border-box;
`;

const Wrapper = styled.div`
  width: 100%;
  max-width: ${TABLET_WIDTH}px;
  text-align: center;
  margin-bottom: 42px;
`;

const HowYouTrain = () => {
  const { inGame } = useContext(PreferencesContext);

  return (
    <Section id="improve">
      <Wrapper>
        {!inGame && <H2>How your kids improve</H2>}

        {inGame && (
          <React.Fragment>
            <H2>Develop your family's true math potential</H2>
            <H5>
              Improve problem-solving and critical thinking skills with our
              award-winning puzzles.
            </H5>
          </React.Fragment>
        )}
        <Carousel />
      </Wrapper>

      {inGame && <ScrollTo selector="#getting-started" />}
    </Section>
  );
};

export default HowYouTrain;
